import { useState, useEffect, createRef } from "react";
import { useSelector } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";
import { RootState } from "../../redux/store";
import {
  blockMember,
  getMemberPremiumStatus,
  sendFirstMeetingDoubleMatchApproval,
} from "../../services/memberService";
import {
  DoubleMatchType,
  GAActions,
  GACategoryName,
  GAEventNames,
  GAUniqueEventIds,
  GenderType,
} from "../../helpers/Enums";
import NiceModal from "@ebay/nice-modal-react";
import { useDispatch } from "react-redux";
import { setProfileMemberData } from "../../redux/profileMember";
import StickersPopup from "../../components/stickers_gift/StickersPopup";
import { getMemberDoubleMatchSticker } from "../../services/mediaService";
import PremiumMessagePopup from "../../components/premium/PremiumMessagePopup";
import { recordGaEvent } from "../../helpers/GoogleAnalytics";
import { sendTextMesssage } from "../../services/messageService";
import { IsEmptyOrNullString } from "../../helpers/Strings";
import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";
import ToastSnackbar from "../../components/ToastSnackbar";
import usePrepareLink from "../../hooks/usePrepareLink";
import { GET_PARAMS, GET_POPUPS } from "../../const/router";

const BounakirMessage = ({
  bounakirMessage,
  doubleMatchType,
  memberCode,
  memberName,
  memberImage,
  userName,
}: any) => {
  const [openToastMessage, setOpenToastMessage] = useState(false);

  const [doubleMatch, setDoubleMatch] = useState<number>(-1);
  const { memberCode: myMemberCode } = useSelector(
    (state: RootState) => state.member
  );
  const [message, setMessage] = useState<string>("");
  const [headerText, setHeaderText] = useState<string>("");
  const [error, setError] = useState<string>("");
  const [switchClosingFormText, setSwitchClosingFormText] =
    useState<boolean>(false);
  const history = useHistory();
  const dispatch = useDispatch();
  const member = useSelector((state: RootState) => state.member);
  const formInput: any = createRef();
  const re = /\d{5,}|@/gm;

  const [showPremium, setshowPremium] = useState<boolean>(false);
  const [isOpendPremium, setIsOpendPremium] = useState<boolean>(false);

  //stickers
  const [showStickers, setShowStickers] = useState<boolean>(false);
  const [stickerUrl, setStickerUrl] = useState<string>(
    "assets/images/ic_gift.svg"
  );
  const [recivedStickerUrl, setRecivedStickerUrl] = useState<string>("");
  const [sendStickerUrl, setSendStickerUrl] = useState<string>("");
  const [stickerId, setStickerId] = useState<number>(-1);

  const location = useLocation();

  //TODO: For testings
  // const link = usePrepareLink({
  //   state: {
  //     navigateFromProfile: true,
  //   },
  //   query: {
  //     [GET_PARAMS.memberCode]: member.memberCode,
  //   },
  //   pushToQuery: {
  //     [GET_PARAMS.popup]: GET_POPUPS.popup.profile,
  //   },
  //   keepOldQuery: true,
  // });

  const premiumMessagelink = usePrepareLink({
    state: {
      navigateFromProfile: true,
    },
    // query: {
    //   [GET_PARAMS.memberCode]: member.memberCode,
    //   [GET_PARAMS.popup]: GET_POPUPS.popup.profile,
    // },
    pushToQuery: {
      [GET_PARAMS.popup]: GET_POPUPS.popup.premiumMessage,
    },
    // keepOldQuery: true,
  });

  function toggleStickers(): void {
    setShowStickers(!showStickers);
  }

  useEffect(() => {
    setSwitchClosingFormText(doubleMatchType === 2);
    setMessage(bounakirMessage ?? "");
    setDoubleMatch(doubleMatchType);
    initlizeHaderText(doubleMatchType);

    if (doubleMatchType === DoubleMatchType.OtherSentMessage) {
      hasRecivedSticker();
    } else if (doubleMatchType === DoubleMatchType.SentMessage) {
      haveISendSticker();
    }
  }, []);
  function togglePremium(): void {
    setshowPremium(!showPremium);
    setIsOpendPremium(!isOpendPremium);
  }

  const setSticker = (imgUlr: string, stickerId: number) => {
    setStickerUrl(imgUlr);
    setStickerId(stickerId);
  };

  //stickers that i recived from other members
  const hasRecivedSticker = async () => {
    const {
      data: { stickerUrl },
    } = await getMemberDoubleMatchSticker(memberCode, true);
    stickerUrl && setRecivedStickerUrl(stickerUrl);
  };
  //stickers that i send to other members
  const haveISendSticker = async () => {
    const {
      data: { stickerUrl },
    } = await getMemberDoubleMatchSticker(memberCode, false);
    stickerUrl && setSendStickerUrl(stickerUrl);
  };

  const checkMemberPremiumStatusToSendStickers = async () => {
    const { data: isPremium } = await getMemberPremiumStatus(2);

    if (isPremium) {
      // console.log("11111");
      // Set or update the selectGifts parameter
      toggleStickers();
    } else {
      //togglePremiumLink
      // console.log("22222");

      //TODO: For Testings!
      history.push(premiumMessagelink);

      // console.log(
      //   "checkMemberPremiumStatusToSendStickers premiumMessagelink:",
      //   premiumMessagelink
      // );

      //TODO: Put it back!!!
      // togglePremium();

      // const memberObject = {
      //   bounakirMessage,
      //   doubleMatchType,
      //   memberImage,
      //   memberName,
      //   memberCode,
      //   userName,
      // };

      // NiceModal.show("premiumMessage_modal", {
      //   // ...memberObject,
      //   isOpened: isOpendPremium,
      //   togglePremium: togglePremium,
      //   isToggle: true,
      // });

      // // Get the current URL
      // let currentUrl = window.location.href;

      // // Check if 'popup=premiumMessage' already exists
      // if (!currentUrl.includes("popup=premiumMessage")) {
      //   // Append '&popup=premiumMessage' to the existing URL
      //   if (currentUrl.includes("?")) {
      //     currentUrl += "&popup=premiumMessage";
      //   } else {
      //     currentUrl += "?popup=premiumMessage";
      //   }
      // }

      // console.log(
      //   "checkMemberPremiumStatusToSendStickers currentUrl: ",
      //   currentUrl
      // );

      // // Use pushState to update the URL without reloading the page
      // window.history.pushState(null, "", currentUrl);

      // url.searchParams.set('popup', 'premiumMessage');  // Add or update the 'popup' query parameter

      // // Now use pushState to update the URL without reloading the page
      // history.pushState(null, '', url);

      // const openModalHashStateId = `${location.pathname}${location.search}&popup=premiumMessage`;
      // console.log(
      //   "checkMemberPremiumStatusToSendStickers openModalHashStateId: ",
      //   openModalHashStateId
      // );

      // window.history.pushState(
      //   { openModalHashStateId },
      //   `${openModalHashStateId}`,
      //   `${openModalHashStateId}`
      // );
    }
  };

  const initlizeHaderText = (doubleMatchType: number) => {
    let headerText =
      doubleMatchType === DoubleMatchType.SentMessage
        ? `נהדר, שלחת ל${userName} הצעת היכרות`
        : // doubleMatchType === DoubleMatchType.OtherSentMessage ? "" : "בואו נכיר";
        doubleMatchType === DoubleMatchType.OtherSentMessage
        ? ""
        : "";

    // doubleMatchType === DoubleMatchType.OtherSentMessage ? "בקשת בואו נכיר" : "בואו נכיר"; what was before
    setHeaderText(headerText);
  };

  const onSubmit = async (event: any, doubleMatch: number) => {
    event.preventDefault();
    // setOpenToastMessage(false);

    console.log({ message });
    // debugger;

    if (IsEmptyOrNullString(message)) {
      setOpenToastMessage(true);
      return;
    }

    if (re.test(message)) {
      setError("לא ניתן לשלוח מייל או טלפון");
      return;
    }

    recoredGaBounakirTypes(doubleMatch);
    // await sendDoubleMatchRequest(myMemberCode, memberCode, message, stickerId);

    await sendFirstMeetingDoubleMatchApproval(
      myMemberCode,
      memberCode,
      message,
      stickerId
    );

    const createMessage = {
      text: message,
      memberCode: myMemberCode,
      chatMemberCode: memberCode,
    };

    await sendTextMesssage(createMessage);

    dispatch(setProfileMemberData({ needToRefresh: true }));
    if (doubleMatch === DoubleMatchType.SentMessage) {
      setDoubleMatch(DoubleMatchType.SentMessage);
      initlizeHaderText(DoubleMatchType.SentMessage);
    } else onClose();

    setSwitchClosingFormText(true);
  };

  const recoredGaBounakirTypes = (doubleMatchType: number) => {
    if (doubleMatchType === DoubleMatchType.SentMessage) {
      recordGaEvent(
        GAEventNames.SEND_BOUNAKIR,
        GACategoryName.BOUNAKIR,
        GAActions.SEND_BOUNAKIR,
        member.nickName,
        GAUniqueEventIds.SEND_BOUNAKIR
      );
    } else if (doubleMatchType === DoubleMatchType.OtherSentMessage) {
      recordGaEvent(
        GAEventNames.ACCEPTED_BOUNAKIR,
        GACategoryName.BOUNAKIR,
        GAActions.ACCEPTED_BOUNAKIR,
        member.nickName,
        GAUniqueEventIds.ACCEPTED_BOUNAKIR
      );
    }
  };

  //check if you are at the start of interaction ie if you are sending bounakir messages
  const isSendingBounakir = () => {
    return (
      !(doubleMatch === DoubleMatchType.SentMessage) &&
      !(doubleMatch === DoubleMatchType.OtherSentMessage)
    );
  };
  const isRecivingBounakir = () => {
    return (
      !(doubleMatch === DoubleMatchType.SentMessage) &&
      doubleMatch === DoubleMatchType.OtherSentMessage
    );
  };
  const onClose = () => {
    NiceModal.hide("bounkair_modal");
    if (DoubleMatchType.SentMessage === doubleMatch) {
      history.go(-2);
    } else {
      history.goBack();
    }
  };

  const handleRejectBonakir = async () => {
    onClose();
    await blockMember(myMemberCode, memberCode);
  };

  const handleCloseToastMessage = (
    event?: React.SyntheticEvent | Event,
    reason?: string
  ) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenToastMessage(false);
  };

  return (
    <>
      <div className="meet_form_block w-form">
        <div className="meet_sec" style={{ lineHeight: "unset" }}>
          <a href="#" className="meet_close w-inline-block" onClick={onClose}>
            <img src="/assets/images/ic_back_white.svg" loading="lazy" alt="" />
          </a>

          {/* <div className="login_logo meet">
                  <img src="/assets/images/shoshke_logo_notxt.svg" loading="lazy" alt="" />
               </div> */}
          <h1 className="meet_title">{headerText}</h1>

          {isSendingBounakir() && (
            <h1 className="meet_title">רוצה להכיר את {userName}?</h1>
          )}
          {isRecivingBounakir() && (
            <h1 className="meet_title">קיבלת מ{userName} הצעת היכרות</h1>
          )}
          {/* {doubleMatch === DoubleMatchType.SentMessage && (
            <h4 style={{ fontWeight: "normal" }}>
              אחרי שההצעה תאושר על ידי {userName} תוכלו להתחיל להתכתב ולקחת את
              ההיכרות הלאה
            </h4>
          )} */}
          <div className="meet_picts_group">
            <div className="meet_pict">
              {memberImage && (
                <img
                  src={memberImage}
                  loading="lazy"
                  alt=""
                  className="item_pict"
                />
              )}
            </div>
          </div>
          <div className="meet_form w-form">
            {doubleMatch === DoubleMatchType.SentMessage ? (
              <>
                {message && (
                  <label className="meet_label"> ההודעה ששלחת:</label>
                )}
                {message && <div className="meet_report">{message}</div>}
                {/*sticker that is seen when member sends it with his bounakir message*/}
                {stickerUrl !== "assets/images/ic_gift.svg" && (
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      marginTop: "5px",
                    }}
                  >
                    {" "}
                    <img
                      src={stickerUrl}
                      loading="lazy"
                      alt=""
                      className="gift_button_pict sending"
                    />{" "}
                  </div>
                )}
                {/* sticker that i have send to other member */}
                {sendStickerUrl && (
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      marginTop: "5px",
                    }}
                  >
                    {" "}
                    <img
                      src={sendStickerUrl}
                      loading="lazy"
                      alt=""
                      className="gift_button_pict sending"
                    />{" "}
                  </div>
                )}
              </>
            ) : doubleMatch === DoubleMatchType.OtherSentMessage ? (
              <form
                onSubmit={(e) => onSubmit(e, DoubleMatchType.OtherSentMessage)}
              >
                <div className="field_block meet">
                  {message && <div className="meet_report">{message}</div>}
                </div>
                {/* sticker i have recived from other members */}
                {recivedStickerUrl && (
                  <img
                    src={recivedStickerUrl}
                    loading="lazy"
                    alt=""
                    className="gift_button_pict sending"
                  />
                )}

                <div className="form_buttons_group meet">
                  <input
                    autoComplete="off"
                    type="submit"
                    value="אישור היכרות"
                    data-wait
                    className="button_full meet w-button"
                  />
                  <a
                    className="skip_link meet_exit"
                    onClick={handleRejectBonakir}
                    href="#"
                  >
                    <div>
                      {member.genderId == GenderType.MALE
                        ? "אני לא מעוניין"
                        : "אני לא מעוניינת"}
                    </div>
                  </a>
                </div>
              </form>
            ) : (
              <form onSubmit={(e) => onSubmit(e, DoubleMatchType.SentMessage)}>
                {/* this is the form for sending bounakir message */}
                <div className="form_field_content meet">
                  <div className="field_block meet">
                    {/* <label htmlFor="name" className="meet_label">
                                       רוצה להכיר את {userName}?
                                    </label> */}

                    {/* <label className="meet_label">
                      כדאי להוסיף להצעה הודעת פתיחה נחמדה במילים שלך
                    </label> */}
                    <label className="meet_label">
                      כתבו הודעת פתיחה נחמדה במילים שלכם
                    </label>

                    <textarea
                      value={message}
                      maxLength={5000}
                      placeholder={` למשל: לספר על עצמך, לכתוב מה הסיבה שבחרת לפנות או פשוט להגיד "היי" :)`}
                      className="meet_field w-input"
                      onChange={(e) => setMessage(e.target.value)}
                    />

                    {error && (
                      <p
                        style={{
                          fontSize: "1.3rem",
                          color: "red",
                          margin: "15px",
                        }}
                      >
                        {error}
                      </p>
                    )}
                  </div>
                </div>
                {/* <div className="form_buttons_group meet" style={{ margin: "0px" }}>
                                 <input autoComplete="off"
                                    type="submit"
                                    value="שליחת הצעת היכרות"
                                    data-wait
                                    className="button_full bou w-button"
                                    style={{ marginBottom: "0px" }}
                                 />
                              </div> */}

                <div className="form_buttons_group meet">
                  {/*if there is a gift show it with it*/}

                  <a
                    onClick={() => {
                      checkMemberPremiumStatusToSendStickers();
                    }}
                    className="gift_button w-inline-block"
                    style={{ cursor: "pointer" }}
                  >
                    <img
                      src={stickerUrl}
                      loading="lazy"
                      alt=""
                      className="gift_button_pict"
                    />
                    {stickerUrl !== "assets/images/ic_gift.svg" ? (
                      <div>החלפת מתנה</div>
                    ) : (
                      <div>הוספת מתנה</div>
                    )}
                  </a>
                </div>

                <div className="content_block footer">
                  <a
                    data-wait
                    onClick={() => {
                      formInput.current.click();
                    }}
                    className="button_icon w-inline-block "
                    style={{ cursor: "pointer" }}
                  >
                    <div> שליחת הצעת היכרות </div>
                    {/* <div> שליחת הודעת פתיחה </div> */}
                    <img
                      src="assets/images/ic_shosh_white.svg"
                      loading="lazy"
                      alt=""
                      className="ic_button"
                    />
                  </a>
                </div>
                <input
                  ref={formInput}
                  autoComplete="off"
                  type="submit"
                  value=" "
                  data-wait
                  className=""
                  style={{ display: "none" }}
                />
              </form>
            )}
          </div>
          <a onClick={onClose} href="#">
            {switchClosingFormText ? (
              <div className="button_full w-button">סיום</div>
            ) : (
              <div style={{ marginTop: "0px" }} className="skip_link meet_exit">
                סגירה
              </div>
            )}
          </a>
        </div>
      </div>
      <StickersPopup
        showStickers={showStickers}
        toggleStickers={toggleStickers}
        setStickerUrl={setStickerUrl}
        setSticker={setSticker}
      />
      <PremiumMessagePopup
        isToggle={true}
        togglePremium={togglePremium}
        isOpened={isOpendPremium}
      />
      <ToastSnackbar
        isOpenToastMessage={openToastMessage}
        handleCloseToastMessage={handleCloseToastMessage}
        toastMessage="הצעת היכרות צריכה לכלול טקסט, מומלץ להציג את עצמך בכמה מילים"
        severity="error"
      />
    </>
  );
};

export default BounakirMessage;
